import React from 'react'
import styled from '@emotion/styled'
import GatsbyImage from 'gatsby-image'
import { navigate } from '@reach/router'
import { BreakPoint } from 'src/components/shared/CssValues'
import Tag from 'src/components/molecules/Tag'
import { Typography } from 'src/components/atoms/Typography'

const BlogListItem = ({ title, date, thumbnail, tags = [] }) => (
  <BlogPost>
    <ThumbnailWrapper>
      {thumbnail && (
        <Thumbnail
          fluid={thumbnail.childImageSharp.fluid}
          imgStyle={{ objectFit: 'contain' }}
        />
      )}
    </ThumbnailWrapper>
    <TextBlock>
      <Title as="h1">{title}</Title>
      <Tags>
        {tags.map(tag => {
          if (!tag) {
            return
          }
          return (
            <Tag
              key={tag}
              small
              isHighlight
              onClick={e => {
                e.preventDefault()
                navigate(`?tag=${tag}`)
              }}
            >
              {tag}
            </Tag>
          )
        })}
      </Tags>
      <Date as="p">{date}</Date>
    </TextBlock>
  </BlogPost>
)

const BlogPost = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
    display: block;
  }
`

const ThumbnailWrapper = styled.div`
  margin: 0.5em 0 0;
  width: 31.313%;
  @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
    width: 100%;
  }
`

const Thumbnail = styled(GatsbyImage)``

const TextBlock = styled.div`
  width: 64.444%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
    width: 100%;
  }
`

const Title = styled(Typography)`
  font-size: 22px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.7;
  letter-spacing: 1.76px;
  text-align: left;
  color: #22475d;
  flex: 1;
  @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
    font-size: 16px;
    line-height: 1.6;
    margin-top: 10px;
  }
`

const Tags = styled.div`
  text-align: left;
  margin: 6px 0;

  & > * {
    margin: 10px 10px 0 0;
  }

  @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
    margin: 3px 0;
  }
`

const Date = styled(Typography)`
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.21;
  letter-spacing: normal;
  text-align: left;
  color: #333333;
  @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
    font-size: 11px;
  }
`

export default BlogListItem
